module.exports = __webpack_public_path__ + "img/logo.ed5f327c.png";